import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Call } from 'src/app/models/call.model';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';

@Component({
  selector: 'app-pharmacy-pickup',
  templateUrl: './pharmacy-pickup.component.html',
  styleUrls: ['./pharmacy-pickup.component.css'],
  standalone: false
})
export class PharmacyPickupComponent implements OnInit {
  @Input() registeredPharmacy?: Call['foreignPrescriptionData'];
  @ViewChild('pharmacyNameInput') pharmacyNameInput?: ElementRef<HTMLInputElement>;

  readonly formGroup = new FormGroup({
    pharmacyName: new FormControl('', { nonNullable: true }),
    pharmacyAddress: new FormControl('', { nonNullable: true })
  });

  constructor(private matDialog: MatDialog) {}

  ngOnInit(): void {
    const name = this.registeredPharmacy?.pharmacyName || '';
    const address = this.registeredPharmacy?.pharmacyAddress || '';
    this.formGroup.setValue({ pharmacyName: name, pharmacyAddress: address });
    if (name || address) this.formGroup.disable();
    else this.formGroup.enable();
  }

  getCompletedPharmacy(): { name: string; address: string } | undefined {
    if (this.formGroup.disabled) return;
    const name = this.pharmacyName.value.trim();
    const address = this.pharmacyAddress.value.trim();
    return name && address ? { name, address } : undefined;
  }

  async confirmBeforeFinishing(): Promise<boolean> {
    if (this.formGroup.disabled || this.getCompletedPharmacy()) return true;

    const hasPartialPharmacy = !!(this.pharmacyName.value.trim() || this.pharmacyAddress.value.trim());
    const accepted = await this.matDialog.open(DialogComponent, {
      width: '500px',
      maxWidth: '90vw',
      panelClass: ['bg-dark', 'pharmacy-warning-dialog'],
      disableClose: true,
      data: {
        title: 'default_warning_message',
        message: hasPartialPharmacy ? 'foreign_prescription_pharmacy_incomplete_warning' : 'foreign_prescription_pharmacy_missing_warning',
        canCancel: true,
        closeMessage: 'foreign_prescription_complete_pharmacy',
        actions: hasPartialPharmacy ? [] : [{ message: 'foreign_prescription_accept_finish', function: () => undefined }]
      }
    }).afterClosed().toPromise();

    const canFinish = !!accepted && !hasPartialPharmacy;
    if (!canFinish) this.pharmacyNameInput?.nativeElement.focus();
    return canFinish;
  }

  get pharmacyName(): FormControl<string> { return this.formGroup.controls.pharmacyName; }
  get pharmacyAddress(): FormControl<string> { return this.formGroup.controls.pharmacyAddress; }
}
